export default "__VITE_ASSET__BlLNTm2o__"